import { TextField } from "src/components/FormikComponents/TextField";

interface IDefinitionRawProps {
  initialValue: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}

export const DefinitionRaw = (props: IDefinitionRawProps): JSX.Element => {
  const { initialValue, value, onChange, disabled } = props;
  const isDirty = initialValue !== value;

  return (
    <TextField
      className={`field textfield definition_string_control ${isDirty ? "dirty" : ""}`}
      label="Definition"
      value={value}
      onChange={(event: any) => onChange(event?.target?.value)}
      multiline={true}
      minRows={1}
      maxRows={5}
      meta={{
        initialValue: initialValue,
        touched: isDirty,
      }}
      disabled={disabled}
    />
  );
};
